module.exports = __webpack_public_path__ + "img/avatar1.afa1d244.png";